// Manually update titles
document.addEventListener("DOMContentLoaded", function () {
    if (window.location.pathname === "/policies/privacy-policy") {
        const title = document.querySelector("h1");
        if (title) {
            title.innerText = "Privacy Policy";
        }
    } else if (window.location.pathname === "/policies/terms-of-service") {
        const title = document.querySelector("h1");
        if (title) {
            title.innerText = "Terms and Conditions";
        }
    }
});